<template>
  <a-tag color="warning" v-if="id == 1">
    <template #icon>
      <exclamation-circle-outlined />
    </template>
    {{ text }}
  </a-tag>

  <a-tag color="cyan" v-if="id == 2">
    <template #icon>
      <clock-circle-outlined :spin="true" />
    </template>
    {{ text }}
  </a-tag>

  <a-tag color="success" v-if="id == 4">
    <template #icon>
      <check-circle-outlined />
    </template>
    {{ text }}
  </a-tag>

  <a-tag color="error" v-if="id == 5">
    <template #icon>
      <close-circle-outlined />
    </template>
    {{ text }}
  </a-tag>

  <a-tag color="processing" v-if="id == 3">
    <template #icon>
      <sync-outlined :spin="true" />
    </template>
    {{ text }}
  </a-tag>
</template>

<script>
import {
  CheckCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons-vue';

export default {
  components: {
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    SyncOutlined,
    ClockCircleOutlined,
  },
  props : ['id','text']
};
</script>